import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, Fragment as _Fragment, withCtx as _withCtx, withKeys as _withKeys, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a16bc8e4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "userImage" }
const _hoisted_2 = { class: "verificationBadge" }
const _hoisted_3 = { class: "userDashboard" }
const _hoisted_4 = { class: "genderIcon" }
const _hoisted_5 = { class: "number" }
const _hoisted_6 = { class: "profilePower" }
const _hoisted_7 = { class: "c-m-0" }
const _hoisted_8 = { class: "c-m-0" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "grayWide dark c-mtb-2" }, null, -1))
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { class: "profilePower" }
const _hoisted_12 = { class: "c-m-0" }
const _hoisted_13 = { class: "c-m-0" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "grayWide dark c-mtb-2" }, null, -1))
const _hoisted_15 = { class: "userProfileData" }
const _hoisted_16 = {
  key: 0,
  class: "icon-warpit_icon_check-round icon"
}
const _hoisted_17 = {
  key: 0,
  class: "icon-warpit_icon_check-round icon"
}
const _hoisted_18 = { class: "user-contact-info__ellipsis" }
const _hoisted_19 = { class: "flex" }
const _hoisted_20 = { class: "small" }
const _hoisted_21 = { class: "user-contact-info__ellipsis" }
const _hoisted_22 = { class: "big" }
const _hoisted_23 = { class: "user-contact-info__ellipsis" }
const _hoisted_24 = { class: "user-contact-info__ellipsis" }
const _hoisted_25 = { class: "user-contact-info__ellipsis" }
const _hoisted_26 = { key: 0 }
const _hoisted_27 = { class: "user-contact-info__ellipsis" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "grayWide" }, null, -1))
const _hoisted_29 = { key: 0 }
const _hoisted_30 = { class: "mt-0" }
const _hoisted_31 = { class: "p-float-label error-label" }
const _hoisted_32 = { for: "password" }
const _hoisted_33 = { key: 0 }
const _hoisted_34 = {
  key: 1,
  class: "verificationStatus"
}
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon-warpit_icon_check-round icon" }, null, -1))
const _hoisted_36 = { class: "text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AvatarCustom = _resolveComponent("AvatarCustom")!
  const _component_ProgressBar = _resolveComponent("ProgressBar")!
  const _component_Button = _resolveComponent("Button")!
  const _component_SidebarUserWrapper = _resolveComponent("SidebarUserWrapper")!
  const _component_Password = _resolveComponent("Password")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_ErrorDialog = _resolveComponent("ErrorDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.user)
      ? (_openBlock(), _createBlock(_component_SidebarUserWrapper, {
          key: 0,
          title: _ctx.$t('city.my_city'),
          sidebarComponent: _ctx.sidebarComponent,
          name: _ctx.user.first_name + ' ' + _ctx.user.last_name
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createVNode(_component_AvatarCustom, {
                src: _ctx.$store.getters['user/userImage'],
                class: "larger"
              }, null, 8, ["src"]),
              _createElementVNode("span", _hoisted_2, [
                _createElementVNode("span", {
                  class: _normalizeClass(`icon-warpit_icon_verification` + _ctx.user.verification_level)
                }, null, 2)
              ])
            ]),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("span", {
                  class: _normalizeClass([{
            'icon-warpit_icon_Female': _ctx.user.gender_id === 0,
            'icon-warpit_icon_Male': _ctx.user.gender_id !== 0,
          }, "icon"])
                }, null, 2),
                _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.calculateAge(_ctx.user)), 1)
              ]),
              _createVNode(_component_ProgressBar, {
                value: _ctx.calculateAccountCompletion()
              }, null, 8, ["value"]),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("h3", _hoisted_7, _toDisplayString(_ctx.$t("user_profile.profile_completion")) + " " + _toDisplayString(_ctx.calculateAccountCompletion()) + "% ", 1),
                _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.$t("user_profile.profile_completion_desc")), 1)
              ]),
              _createVNode(_component_Button, {
                "event-name": "editProfileButton",
                "event-from": "/user/my-profile",
                class: "defaultButton whiteBG",
                label: _ctx.$t('user_profile.edit_profile'),
                onClick: _ctx.editProfileButtonClicked
              }, null, 8, ["label", "onClick"]),
              _hoisted_9,
              (
          _ctx.user.email_verified_at === null && _ctx.user.phone_verified_at === null
        )
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("h3", _hoisted_12, _toDisplayString(_ctx.$t("user_email.profile_not_verified")), 1),
                      _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.$t("user_email.profile_verify_desc")), 1)
                    ]),
                    _createVNode(_component_Button, {
                      class: "defaultButton whiteBG",
                      label: _ctx.$t('user_email.verify_profile'),
                      onClick: _ctx.verifyProfile
                    }, null, 8, ["label", "onClick"]),
                    _hoisted_14
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("h3", null, _toDisplayString(_ctx.$t("user_profile.contact_info")), 1),
                _createElementVNode("ul", null, [
                  _createElementVNode("li", null, [
                    _createElementVNode("label", null, _toDisplayString(_ctx.$t("user_profile.phone")), 1),
                    _createElementVNode("span", {
                      class: _normalizeClass({
                verifySpan:
                  _ctx.user.phone_number !== null && _ctx.user.phone_verified_at === null,
              })
                    }, _toDisplayString(_ctx.user.phone_number), 3),
                    (
                _ctx.user.phone_number !== null && _ctx.user.phone_verified_at !== null
              )
                      ? (_openBlock(), _createElementBlock("span", _hoisted_16))
                      : _createCommentVNode("", true),
                    (
                _ctx.user.phone_number !== null &&
                _ctx.user.phone_verified_at === null &&
                _ctx.user.email_verified_at !== null
              )
                      ? (_openBlock(), _createBlock(_component_Button, {
                          key: 1,
                          class: "defaultButton verifyButton",
                          label: _ctx.$t('user_phone.verify'),
                          onClick: _ctx.sendSms
                        }, null, 8, ["label", "onClick"]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("li", null, [
                    _createElementVNode("label", null, _toDisplayString(_ctx.$t("user_profile.email")), 1),
                    _createElementVNode("span", {
                      class: _normalizeClass([
                'my-profile__email-text',
                {
                  verifySpan:
                    _ctx.user.email !== null && _ctx.user.email_verified_at === null,
                },
              ])
                    }, [
                      _createTextVNode(_toDisplayString(_ctx.user.email) + " ", 1),
                      (_ctx.user.email_verified_at !== null)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_17))
                        : _createCommentVNode("", true)
                    ], 2),
                    (
                _ctx.user.email !== null &&
                _ctx.user.email_verified_at === null &&
                _ctx.user.phone_verified_at !== null
              )
                      ? (_openBlock(), _createBlock(_component_Button, {
                          key: 0,
                          class: "defaultButton verifyButton",
                          label: _ctx.$t('user_phone.verify'),
                          onClick: _ctx.sendEmail
                        }, null, 8, ["label", "onClick"]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                (_ctx.user.contact_info)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createElementVNode("h3", null, _toDisplayString(_ctx.$t("user_profile.address")), 1),
                      _createElementVNode("ul", null, [
                        _createElementVNode("li", null, [
                          _createElementVNode("label", null, _toDisplayString(_ctx.$t("user_profile.address_info")), 1),
                          _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.user.contact_info.address) + " " + _toDisplayString(_ctx.user.contact_info.house_number), 1)
                        ]),
                        _createElementVNode("li", _hoisted_19, [
                          _createElementVNode("div", _hoisted_20, [
                            _createElementVNode("label", null, _toDisplayString(_ctx.$t("user_profile.post_number")), 1),
                            _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.user.contact_info.code), 1)
                          ]),
                          _createElementVNode("div", _hoisted_22, [
                            _createElementVNode("label", null, _toDisplayString(_ctx.$t("user_profile.city")), 1),
                            _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.user.contact_info.city), 1)
                          ])
                        ]),
                        _createElementVNode("li", null, [
                          _createElementVNode("label", null, _toDisplayString(_ctx.$t("user_profile.municipality")), 1),
                          _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.user.contact_info.municipality), 1)
                        ]),
                        _createElementVNode("li", null, [
                          _createElementVNode("label", null, _toDisplayString(_ctx.$t("user_profile.country")), 1),
                          _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.user.contact_info.country), 1)
                        ]),
                        (_ctx.user.contact_info.local_community && _ctx.localCommunityEnabled)
                          ? (_openBlock(), _createElementBlock("li", _hoisted_26, [
                              _createElementVNode("label", null, _toDisplayString(_ctx.$t("user_profile.local_community")), 1),
                              _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.user.contact_info.local_community.title), 1)
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ], 64))
                  : _createCommentVNode("", true),
                _hoisted_28
              ]),
              _createVNode(_component_Button, {
                "event-name": "changePasswordButton",
                "event-from": "/user/my-profile",
                class: "defaultButton whiteBG",
                label: _ctx.$t('user_profile.change_password'),
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({ name: 'ChangePassword' })))
              }, null, 8, ["label"]),
              _createVNode(_component_Button, {
                "event-name": "profileExportButton",
                "event-from": "/user/my-profile",
                class: "defaultButton whiteBG",
                label: _ctx.$t('user_profile.export'),
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showExportDialog = true))
              }, null, 8, ["label"]),
              _createVNode(_component_Button, {
                "event-name": "userDeleteButton",
                "event-from": "/user/my-profile",
                class: "defaultButton whiteBG",
                label: _ctx.$t('user_profile.delete_profile'),
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.push({ name: 'DeleteProfile' })))
              }, null, 8, ["label"]),
              _createVNode(_component_Button, {
                "event-name": "logoutButton",
                "event-from": "/user/my-profile",
                class: "defaultButton whiteBG",
                label: _ctx.$t('user_profile.logout'),
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.logout()))
              }, null, 8, ["label"])
            ])
          ]),
          _: 1
        }, 8, ["title", "sidebarComponent", "name"]))
      : _createCommentVNode("", true),
    _createVNode(_component_Dialog, {
      visible: _ctx.showExportDialog,
      "onUpdate:visible": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.showExportDialog) = $event)),
      class: "successDialog",
      header: _ctx.$t('user_profile.data_export'),
      onHide: _cache[10] || (_cache[10] = ($event: any) => (_ctx.closeExportDialog()))
    }, {
      default: _withCtx(() => [
        (!_ctx.showSuccessExportDialog)
          ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
              _createElementVNode("p", _hoisted_30, _toDisplayString(_ctx.$t("user_profile.data_export_description")), 1),
              _createElementVNode("span", _hoisted_31, [
                _createVNode(_component_Password, {
                  id: "password",
                  toggleMask: "",
                  feedback: false,
                  modelValue: _ctx.exportPassword,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.exportPassword) = $event)),
                  name: "password"
                }, null, 8, ["modelValue"]),
                _createElementVNode("label", _hoisted_32, _toDisplayString(_ctx.$t("user_profile.password")), 1),
                (_ctx.exportError)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_33, _toDisplayString(_ctx.exportError), 1))
                  : _createCommentVNode("", true)
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_34, [
              _hoisted_35,
              _createElementVNode("span", _hoisted_36, _toDisplayString(_ctx.$t("dialog.success_export")), 1)
            ])),
        (!_ctx.showSuccessExportDialog)
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 2,
              class: "defaultButton",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.exportProfileData())),
              style: {"justify-content":"center"},
              onKeypress: _cache[6] || (_cache[6] = _withKeys(($event: any) => (_ctx.exportProfileData()), ["enter"])),
              tabindex: "0"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("user_profile.export")), 1)
              ]),
              _: 1
            }))
          : (_openBlock(), _createBlock(_component_Button, {
              key: 3,
              class: "defaultButton",
              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.showExportDialog = false)),
              style: {"justify-content":"center"},
              onKeypress: _cache[8] || (_cache[8] = _withKeys(($event: any) => (_ctx.showExportDialog = false), ["enter"])),
              tabindex: "0"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("dialog.close")), 1)
              ]),
              _: 1
            }))
      ]),
      _: 1
    }, 8, ["visible", "header"]),
    (_ctx.showErrorDialog)
      ? (_openBlock(), _createBlock(_component_ErrorDialog, {
          key: 1,
          onClose: _cache[11] || (_cache[11] = ($event: any) => (_ctx.showErrorDialog = false))
        }))
      : _createCommentVNode("", true)
  ], 64))
}